import { Tooltip, TooltipContent, TooltipTrigger } from '@bpinternal/ui-kit-next'
import { type ReactNode } from 'react'

type Props = {
  timestamp: Date
  children: ReactNode
}

const formatTimestamp = (date: Date) => {
  const dateStr = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(date)
  const timeStr = new Intl.DateTimeFormat(undefined, { timeStyle: 'short' }).format(date)
  return `Sent on ${dateStr} at ${timeStr}`
}

export const MessageTimestampTooltip = ({ timestamp, children }: Props) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent>{formatTimestamp(timestamp)}</TooltipContent>
    </Tooltip>
  )
}
